var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg124Screen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "7.267%",
    x2: "92.86%",
    y1: "-3.532%",
    y2: "90.134%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3d6d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#f6d8da"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "123---Monitor-Settings",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55 1h-50c-2.209139 0-4 1.790861-4 4v37c0 3.3137085 2.6862915 6 6 6h23.63c.0226266.1935673.1108535.3735503.25.51l1.61 1.61c.271109.2734117.6887247.338284 1.03.16l2.48-1.24.68-.34c1.0064358.592955 2.0900314 1.0438923 3.22 1.34l1.12 3.35c.1172053.3646203.4570077.6113816.84.61h2.28c.3829923.0013816.7227947-.2453797.84-.61l1.12-3.35c1.1299686-.2961077 2.2135642-.747045 3.22-1.34l3.16 1.58c.3412753.178284.758891.1134117 1.03-.16l1.61-1.61c.253811-.2550815.328818-.6380118.19-.97 2.2329969-.9355764 3.6872535-3.1189319 3.69-5.54v-37c0-2.209139-1.790861-4-4-4z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32.3 44.32-1.58 3.16c-.0827389.1599612-.1141653.3415362-.09.52h-23.63c-3.3137085 0-6-2.6862915-6-6v-3h26v.14c-.0013816.3829923.2453797.7227947.61.84l3.35 1.12c.2961077 1.1299686.747045 2.2135642 1.34 3.22z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59.0000058 39.14-.0000058 2.86c-.0027465 2.4210681-1.4570031 4.6044236-3.69 5.54h-.01c-.0020713-.0212492-.0089076-.0417578-.02-.06l-1.58-3.16c.592955-1.0064358 1.0438923-2.0900314 1.34-3.22l3.35-1.12c.3646203-.1172053.6113816-.4570077.6100058-.84z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m56 7v28.221l2.39.8c.3646203.1172053.6113816.4570077.6100058.84v-29.861z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 5v2h-58v-2c0-2.209139 1.790861-4 4-4h50c2.209139 0 4 1.790861 4 4z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55 1h-3c2.209139 0 4 1.790861 4 4v2h3v-2c0-2.209139-1.790861-4-4-4z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m41 59h-22s5-2 5-6v-5h6.63c.0226266.1935673.1108535.3735503.25.51l1.61 1.61c.271109.2734117.6887247.338284 1.03.16l2.48-1.24v3.96c0 4 5 6 5 6z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe7e8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m6 13h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m10 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m10 25h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m6 21h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m6 29h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m14 13h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m18 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m22 13h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m22 21h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m18 25h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m26 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m30 13h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m14 21h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m14 29h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m10 13h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m14 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m14 25h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m10 21h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m10 29h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m6 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m6 25h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m18 13h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m22 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m26 13h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m18 21h4v4h-4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 36.86v2.28c.0013816.3829923-.2453797.7227947-.61.84l-3.35 1.12c-.2961077 1.1299686-.747045 2.2135642-1.34 3.22l1.58 3.16c.0110924.0182422.0179287.0387508.02.06h.01c.138818.3319882.063811.7149185-.19.97l-1.61 1.61c-.271109.2734117-.6887247.338284-1.03.16l-3.16-1.58c-1.0064358.592955-2.0900314 1.0438923-3.22 1.34l-1.12 3.35c-.1172053.3646203-.4570077.6113816-.84.61h-2.28c-.3829923.0013816-.7227947-.2453797-.84-.61l-1.12-3.35c-1.1299686-.2961077-2.2135642-.747045-3.22-1.34l-.68.34-2.48 1.24c-.3412753.178284-.758891.1134117-1.03-.16l-1.61-1.61c-.1391465-.1364497-.2273734-.3164327-.25-.51-.0241653-.1784638.0072611-.3600388.09-.52l1.58-3.16c-.592955-1.0064358-1.0438923-2.0900314-1.34-3.22l-3.35-1.12c-.3646203-.1172053-.6113816-.4570077-.61-.84v-2.28c-.0013816-.3829923.2453797-.7227947.61-.84l3.35-1.12c.2961077-1.1299686.747045-2.2135642 1.34-3.22l-1.58-3.16c-.178284-.3412753-.1134117-.758891.16-1.03l1.61-1.61c.271109-.2734117.6887247-.338284 1.03-.16l3.16 1.58c1.0064358-.592955 2.0900314-1.0438923 3.22-1.34l1.12-3.35c.1172053-.3646203.4570077-.6113816.84-.61h2.28c.3829923-.0013816.7227947.2453797.84.61l1.12 3.35c1.1299686.2961077 2.2135642.747045 3.22 1.34l3.16-1.58c.3412753-.178284.758891-.1134117 1.03.16l1.61 1.61c.2734117.271109.338284.6887247.16 1.03l-1.58 3.16c.592955 1.0064358 1.0438923 2.0900314 1.34 3.22l3.35 1.12c.3646203.1172053.6113816.4570077.61.84z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.04,
    cy: 38.04,
    fill: "#ffe7e8",
    r: 8.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m41.98 22.61 1.12 3.35c1.1299686.2961077 2.2135642.747045 3.22 1.34l1.5-.75c-.5584761-.2375725-1.1332868-.4347459-1.72-.59l-1.12-3.35c-.1172053-.3646203-.4570077-.6113816-.84-.61h-2.28c-.124732.0028817-.2474333.0321937-.36.086.2272165.0984874.4017674.2890388.48.524z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58.39 36.02-3.35-1.12c-.2961077-1.1299686-.747045-2.2135642-1.34-3.22l1.58-3.16c.178284-.3412753.1134117-.758891-.16-1.03l-1.61-1.61c-.271109-.2734117-.6887247-.338284-1.03-.16l-1.42.71 1.06 1.06c.2734117.271109.338284.6887247.16 1.03l-1.58 3.16c.592955 1.0064358 1.0438923 2.0900314 1.34 3.22l3.35 1.12c.3646203.1172053.6113816.4570077.61.84v2.28c.0013816.3829923-.2453797.7227947-.61.84l-3.35 1.12c-.2961077 1.1299686-.747045 2.2135642-1.34 3.22l1.58 3.16c.0110924.0182422.0179287.0387508.02.06h.01c.138818.3319882.063811.7149185-.19.97l-1.06 1.06 1.42.71c.3412753.178284.758891.1134117 1.03-.16l1.61-1.61c.253811-.2550815.328818-.6380118.19-.97h-.01c-.0020713-.0212492-.0089076-.0417578-.02-.06l-1.58-3.16c.592955-1.0064358 1.0438923-2.0900314 1.34-3.22l3.35-1.12c.3646203-.1172053.6113816-.4570077.61-.84v-2.28c.0013816-.3829923-.2453797-.7227947-.61-.84z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m46.32 48.7c-1.0064358.592955-2.0900314 1.0438923-3.22 1.34l-1.12 3.35c-.0782326.2349612-.2527835.4255126-.48.524.1125667.0538063.235268.0831183.36.086h2.28c.3829923.0013816.7227947-.2453797.84-.61l1.12-3.35c.5867132-.1552541 1.1615239-.3524275 1.72-.59z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 38,
    fill: "#ffc9cc",
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 48h3c-3.3137085 0-6-2.6862915-6-6v-37c0-2.209139 1.790861-4 4-4h-3c-2.209139 0-4 1.790861-4 4v37c0 3.3137085 2.6862915 6 6 6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 53v-5h-3v5c0 4-5 6-5 6h3s5-2 5-6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m0 27h2v8h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 31,
    fill: "#ff414c",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55 0h-50c-2.76005315.00330612-4.99669388 2.23994685-5 5v22c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-19h3c.55228475 0 1-.44771525 1-1s-.44771525-1-1-1h-3v-1c0-1.65685425 1.34314575-3 3-3h50c1.6568542 0 3 1.34314575 3 3v1h-48c-.55228475 0-1 .44771525-1 1s.44771525 1 1 1h48v26.835l-2.142-.715c-.2576834-.8546122-.6007464-1.6811125-1.024-2.467l1.345-2.689c.3644673-.7273022.2217944-1.6063125-.354-2.181l-1.608-1.608c-.5748366-.5755034-1.4536484-.7181441-2.181-.354l-2.689 1.345c-.7863227-.4230709-1.6131359-.7661246-2.468-1.024l-.95-2.852c-.2574197-.7708793-.9792765-1.2905195-1.792-1.29h-2.274c-.813089-.0006868-1.5351899.5195321-1.792 1.291l-.95 2.851c-.8548641.2578754-1.6816773.6009291-2.468 1.024l-2.69-1.345c-.7270946-.3636565-1.6053364-.2210429-2.18.354l-1.608 1.608c-.5757944.5746875-.7184673 1.4536978-.354 2.181l1.345 2.689c-.4232536.7858875-.7663166 1.6123878-1.024 2.467l-2.85.951c-.7720568.2561992-1.2928552.978545-1.292 1.792v1.137h-24v-3c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1v7c.00440864 3.8641657 3.13583434 6.9955914 7 7h16v4c0 2.91-3.43 4.644-4.21 5h-9.79c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h50c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-17.791c-.778-.352-4.209-2.072-4.209-5v-3c.6812131.3462879 1.3907998.6336688 2.121.859l.95 2.852c.257766.7704841.9795416 1.2896631 1.792 1.289h2.274c.813089.0006868 1.5351899-.5195321 1.792-1.291l.95-2.851c.8548641-.2578754 1.6816773-.6009291 2.468-1.024l2.69 1.345c.7267969.3656005 1.606234.2227929 2.18-.354l1.608-1.608c.2914003-.294992.4776434-.677669.53-1.089 2.2472272-1.2192693 3.6462483-3.5713135 3.645-6.128v-37c-.0033061-2.76005315-2.2399468-4.99669388-5-5zm-53 42v-2h24.233c.2180603.4361384.5981782.769594 1.059.929l2.85.951c.2576834.8546122.6007464 1.6811125 1.024 2.467l-1.327 2.653h-22.839c-2.76005315-.0033061-4.99669388-2.2399468-5-5zm35.543 16h-15.086c1.5442949-1.2094759 2.4751089-3.0396252 2.543-5v-4h5.018c.0469923.0760513.0994646.1485767.157.217l1.608 1.608c.5742385.5766698 1.4538469.7194398 2.181.354l1.036-.518v2.339c.0678911 1.9603748.9987051 3.7905241 2.543 5zm15.316-8.646-3.093-1.546c-.3040421-.1520701-.6645162-.1392633-.957.034-.9235032.5472681-1.9201501.9604052-2.96 1.227-.3291294.0845885-.5927766.3305336-.7.653l-1.092 3.278h-2.114l-1.092-3.278c-.1072234-.3224664-.3708706-.5684115-.7-.653-1.0398499-.2665948-2.0364968-.6797319-2.96-1.227-.2924838-.1732633-.6529579-.1860701-.957-.034l-.621.31h-.006l-2.466 1.233-1.495-1.495 1.546-3.093c.1520701-.3040421.1392633-.6645162-.034-.957-.5464247-.9226229-.9598387-1.9177791-1.228-2.956-.0843962-.3288942-.3299189-.5924923-.652-.7l-3.278-1.093v-2.114l3.278-1.093c.3220811-.1075077.5676038-.3711058.652-.7.2678947-1.0392578.6813159-2.0354412 1.228-2.959.1732633-.2924838.1860701-.6529579.034-.957l-1.546-3.093 1.495-1.495 3.093 1.546c.3040421.1520701.6645162.1392633.957-.034.9235032-.5472681 1.9201501-.9604052 2.96-1.227.3291294-.0845885.5927766-.3305336.7-.653l1.092-3.278h2.114l1.092 3.278c.1072234.3224664.3708706.5684115.7.653 1.0398499.2665948 2.0364968.6797319 2.96 1.227.2924838.1732633.6529579.1860701.957.034l3.093-1.546 1.495 1.495-1.546 3.093c-.1520701.3040421-.1392633.6645162.034.957.5466841.9235588.9601053 1.9197422 1.228 2.959.0843962.3288942.3299189.5924923.652.7l3.278 1.093v2.114l-3.278 1.093c-.3220811.1075077-.5676038.3711058-.652.7-.2678947 1.0392578-.6813159 2.0354412-1.228 2.959-.1732633.2924838-.1860701.6529579-.034.957l1.546 3.093zm2.888-3.181-.913-1.826c.4232536-.7858875.7663166-1.6123878 1.024-2.467l2.1420011-.715-.0000011.835c.0011131 1.682019-.8460756 3.2511795-2.253 4.173z",
    fill: "#ff414c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30,
    cy: 4,
    fill: "#ff414c",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4 60c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-3c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z",
    fill: "#ff414c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 28c-.55228475 0-1 .4477153-1 1v4c0 .5522847.44771525 1 1 1h4c.5522847 0 1-.4477153 1-1v-3h2v3c0 .5522847.4477153 1 1 1h4c.5522847 0 1-.4477153 1-1v-3h3c.5522847 0 1-.4477153 1-1v-3h3c.5522847 0 1-.4477153 1-1v-3h3c.5522847 0 1-.4477153 1-1v-3h3c.5522847 0 1-.4477153 1-1v-4c0-.5522847-.4477153-1-1-1h-4c-.5522847 0-1 .4477153-1 1v3h-2v-3c0-.5522847-.4477153-1-1-1h-4c-.5522847 0-1 .4477153-1 1v3h-2v-3c0-.5522847-.4477153-1-1-1h-4c-.5522847 0-1 .4477153-1 1v3h-2v-3c0-.5522847-.4477153-1-1-1h-4c-.55228475 0-1 .4477153-1 1v4c0 .5522847.44771525 1 1 1h3v2h-3c-.55228475 0-1 .4477153-1 1v4c0 .5522847.44771525 1 1 1h3v2zm3 4h-2v-2h2zm4-10v2h-2v-2zm12-2h-2v-2h2zm-4 4h-2v-2h2zm-4 0h-2v-2h2zm-2 2h2v2h-2zm2-6h-2v-2h2zm-6 6h2v2h-2zm6 6h-2v-2h2zm4-4h-2v-2h2zm4-4h-2v-2h2zm6-10h2v2h-2zm-2 6h-2v-2h2zm-6-6h2v2h-2zm-2 6h-2v-2h2zm-6-6h2v2h-2zm-2 6h-2v-2h2zm-6-6h2v2h-2zm0 8h2v2h-2z",
    fill: "#ff414c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43 29c-1.1566843-.002064-2.3028094.2200296-3.375.654-.3335959.1323241-.5707036.4332642-.6212995.7885612s.0930794.7104623.3764761.930649c.2833968.2201867.6630531.2716268.9948234.1347898 3.1705589-1.2824124 6.8035972-.0860023 8.5917616 2.8293868s1.2078468 6.6960763-1.3723915 8.9409361-6.4048549 2.2965551-9.0448246.1222539c-2.6399697-2.1743011-3.3222596-5.9379223-1.6135455-8.9005768.2561528-.4759933.0876904-1.0693836-.3803603-1.3397768s-1.0662521-.1199053-1.3506397.3397768c-2.0366897 3.5276501-1.4501212 7.9834487 1.4301313 10.8638247 2.8802525 2.8803759 7.336026 3.4671353 10.8637634 1.4305967 3.5277373-2.0365385 5.2478314-6.1885839 4.1938161-10.123234-1.0540153-3.9346502-4.6193314-6.6708383-8.6927108-6.6711874z",
    fill: "#ff414c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 38c0-2.209139-1.790861-4-4-4s-4 1.790861-4 4 1.790861 4 4 4 4-1.790861 4-4zm-6 0c0-1.1045695.8954305-2 2-2s2 .8954305 2 2-.8954305 2-2 2-2-.8954305-2-2z",
    fill: "#ff414c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg124Screen);
export default __webpack_public_path__ + "static/media/124-screen.25756993349dfbf5d74c2c643463ed3d.svg";
export { ForwardRef as ReactComponent };